export interface AboutProduct {
  name: string
  body: string
}

export interface AboutDict {
  meta: {
    title: string
    description: string
  }
  hero: {
    titleBeforeFirstMark: string
    firstMark: string
    titleAfterFirstMark: string
    titleBeforeSecondMark: string
    secondMark: string
    titleAfterSecondMark: string
    body: string
  }
  products: {
    heading: string
    subheading: string
    items: [AboutProduct, AboutProduct]
  }
  belief: {
    lines: [string, string, string]
  }
  company: {
    heading: string
    subheading: string
    body: string
  }
  footer: {
    brand: string
    copyright: string
  }
}

export const ABOUT_DICT: AboutDict = {
  meta: {
    title: '关于造梦次元 — 从一个念头，到一个世界',
    description:
      '关于造梦次元 Dreama 与深圳想法流科技有限公司：AI 驱动的沉浸式创作社区和创作者平台，让更多人敢于创造。',
  },
  hero: {
    titleBeforeFirstMark: '从一个',
    firstMark: '念头',
    titleAfterFirstMark: '，',
    titleBeforeSecondMark: '到一个',
    secondMark: '世界',
    titleAfterSecondMark: '。',
    body: '一句话，可以召唤出一个角色；一个角色，可以生长成整个世界。在造梦次元，内容不只是被创造，它会被看见、被延续、被重新演绎。每一次创作，都是下一次创作的土壤。',
  },
  products: {
    heading: '我们做的事',
    subheading: '两个产品，一件事——让创作真正发生。',
    items: [
      {
        name: '造梦次元',
        body: 'AI 驱动的沉浸式创作社区。从文本到视频，从角色到世界，让每个参与者既是创造者，也是世界的延续者。有人在造，有人在玩，有人在续写——世界每天都不一样。',
      },
      {
        name: '造梦 AI',
        body: '把模型能力交到创作者手里。将前沿生成式 AI 组件化、工作流化，让创意以更低的阻力落地——你想什么，智能就替你跑什么。',
      },
    ],
  },
  belief: {
    lines: ['AI 最大的价值，', '不是替代创造，', '而是让更多人敢于创造。'],
  },
  company: {
    heading: '关于想法流',
    subheading: '通用人工智能时代的内容科技公司',
    body: '想法流由一群优秀的极客、工程师、科学家一起创立，是一支深耕内容与 AI 领域超过十年的团队，我们既懂内容，也懂 AI。我们见过内容生态如何生长，也知道 AI 在哪个环节真正改变了规则。我们在做的事，是让每一个有故事的人，都能找到自己的世界——以及继续这个世界的人。',
  },
  footer: {
    brand: '造梦次元  Dreama',
    copyright: '© 2026 深圳想法流科技有限公司　版权所有',
  },
}
